import { Link } from 'react-router-dom';
import { useAuth } from '../store/useAuth.js';
import { ROLE_LABELS } from '../validation/roles.js';
import PageHeader from './PageHeader.jsx';
import Card from './Card.jsx';

/**
 * Guards a page behind a permission module. The API enforces the same rule, so
 * this is about not showing someone a form that will only reject them.
 */
export default function RequireModule({ module: moduleName, children }) {
  const { user, can } = useAuth();
  if (can(moduleName)) return children;

  return (
    <>
      <PageHeader eyebrow="Access" title="Not available to your account" />
      <Card>
        <p className="muted" style={{ marginTop: 0, fontSize: 12.5 }}>
          <strong>{moduleName}</strong> is not part of your access. You are signed in as{' '}
          <strong>{ROLE_LABELS[user?.role] || user?.role}</strong>. An administrator can grant this in User Management.
        </p>
        <div className="btn-row">
          <Link className="btn primary" to="/" style={{ textDecoration: 'none' }}>
            Back to dashboard
          </Link>
        </div>
      </Card>
    </>
  );
}
